module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"de":{"Items":"Unsere Produkte"},"en":{"Items":"Our products"},"hu":{"Items":"Termékeink"}}')
}



//////////////////
// WEBPACK FOOTER
// ./~/@kazupon/vue-i18n-loader/lib!./~/vue-loader/lib/selector.js?type=customBlocks&index=0!./src/components/Items.vue
// module id = 370
// module chunks = 0